// Unduh .docx from the PBJ screens and the Template page (Non-Penyedia): the
// Word skeleton of a government template or a node's output, built by the
// API at once without Pluto. The file is saved through an object URL, and
// DOCX_SAVED_EVENT tells the Riwayat pembuatan dokumen to reload. One
// download at a time; `busy` names the key of the one running, `error` the
// one that failed.
import { useState } from "react";
import * as API from "../api";
import type { FeatureState } from "../shell/features";

export const DOCX_SAVED_EVENT = "pluto:docx-saved";

/** Unduh .docx needs the template library and document generation (no chat turn). */
export function canDocx(features: FeatureState): boolean {
  return features.has("templates") && features.has("document_generation");
}

/** Hands the file to the browser's download. */
export function saveFile(file: API.DocxFile): void {
  if (typeof URL.createObjectURL !== "function") return;
  const url = URL.createObjectURL(file.blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export interface DocxState {
  busy: string | null;
  error: { key: string; message: string } | null;
  start: (key: string, call: () => Promise<API.DocxFile>) => Promise<void>;
}

export function useDocx(): DocxState {
  const [busy, setBusy] = useState<string | null>(null);
  const [error, setError] = useState<DocxState["error"]>(null);

  const start: DocxState["start"] = async (key, call) => {
    if (busy) return;
    setBusy(key);
    setError(null);
    try {
      saveFile(await call());
      window.dispatchEvent(new Event(DOCX_SAVED_EVENT));
    } catch (err) {
      setError({ key, message: API.errorMessage(err) });
    } finally {
      setBusy(null);
    }
  };

  return { busy, error, start };
}
